export default "__VITE_ASSET__DfrrIGsR__"